import React, { useEffect, useMemo, useState } from 'react'
import { MaterialReactTable, useMaterialReactTable, } from 'material-react-table'
import API from '@/util/api'
import { tablePageConfig } from '@/util/table'

const Index = () => {
  const [ data, setData ] = useState([])
  const [ rowCount, setRowCount ] = useState(0)
  const [sorting, setSorting] = useState([
    {
      id: 'id',
      desc: true
    }
  ])
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10
  })
  const [globalFilter, setGlobalFilter] = useState('')
  const [isLoading, setLoading] = useState(false)

  const selectList = async (page, rowsPerPage, sortBy, descending, searchTxt) => {
    setLoading(true)
    const res = await API.get('/api/depts', {
      params: {
        page,
        rowsPerPage,
        sortBy,
        descending,
        searchTxt
      }
    }).catch( () => {
      return {
        data: []
      }
    })
    setData(res.data)
    if (res.pageable) {
      setRowCount(res.pageable.rowsNumber)
    }
    setLoading(false)
  }

  useEffect(() => {
    selectList(pagination.pageIndex, pagination.pageSize, sorting[0].id, sorting[0].desc, globalFilter)
  }, [sorting, globalFilter, pagination.pageIndex, pagination.pageSize])

  const columns = useMemo( () => {
    return [
      {
        accessorKey: 'id',
        header: '코드',
        sortDescFirst: true
      },
      {
        accessorKey: 'name',
        header: '이름'
      },
      {
        accessorKey: 'userCnt',
        header: '사용자 수'
      }
    ]
  }, [])

  const creditTable = useMaterialReactTable({
    ...tablePageConfig,
    columns,
    data,
    rowCount,
    state: {
      sorting,
      isLoading,
      showProgressBars: isLoading,
      globalFilter,
      pagination
    },
    onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    onSortingChange: setSorting
  })

  return (
    <div>
      <MaterialReactTable table={creditTable} />
    </div>
  )
}

export default Index
